import styled from 'styled-components'
import { StyleSheet } from 'react-native'

const LoginWrapperComponent = styled.div`
  .Login-particles {
    position: absolute;
    width: 60%!important;
    height: 100%;
    background-color: rgb(7, 12, 16);
  }

  .Login-particles--mobile {
    width: 100%!important;
  }
`

const carouselStyles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: 2
  },
  itemContainer: {
    minHeight: 380
  }
})

const useCarouselItemStyles = (theme) => StyleSheet.create({
  keywords: {
    flexDirection: 'row',
    marginVertical: 10
  },
  keyword: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  separator: {
    width: 5,
    height: 5,
    borderRadius: 100,
    marginHorizontal: 10,
    backgroundColor: theme.LOCHMARA
  }
})

export {
  LoginWrapperComponent,
  carouselStyles,
  useCarouselItemStyles
}
